import { TypeAnimation } from 'react-type-animation';
import 'typeface-roboto';

const MyName = () => {
  return (
    <TypeAnimation
      sequence={[
        'Hi, my name is Sonal Prasad',
        () => {
          console.log('Done typing!'); // Place optional callbacks anywhere in the array
        }
      ]}
      wrapper="div"
      cursor={false}
      repeat={0}
      speed={10}
      style={{ fontSize: '1.5em', fontFamily: 'Roboto'}}
    />
  );
};

export default MyName;